export const smartscoreGrades = [
  {
    level: -2,
    name: 'Du har gode muligheter',
    description:
      'Du har gode muligheter til å spare penger med å være mer bevisst på når du bruker strøm, og hvor mye du bruker samtidig.'
  },
  {
    level: -1,
    name: 'Du har litt å gå på',
    description:
      'Du bruker strømmen på en noe dyrere måte enn gjennomsnittet, og vil fort kunne spare penger hver måned ved å justere litt på strømvanene dine. '
  },
  {
    level: 0,
    name: 'Helt topp',
    description:
      'Du er en bevisst og flink strømforbruker. Fortsett slik!'
  },
  // {
  //   level: -2,
  //   name: 'Du har gode muligheter',
  //   description:
  //     'Du har gode muligheter til å spare penger med å være mer bevisst på når du bruker strøm, og hvor mye du bruker samtidig.'
  // },
  // {
  //   level: -1,
  //   name: 'Du har litt å gå på',
  //   description:
  //     'Du bruker strømmen på en noe dyrere måte enn gjennomsnittet, og vil fort kunne spare penger hver måned ved å justere litt på strømvanene dine. '
  // },
  // {
  //   level: 0,
  //   name: 'Som de fleste',
  //   description:
  //     'Du bruker strømmen som de fleste – og de fleste kan redusere kostnadene sine med enkle grep.'
  // },
  // {
  //   level: 1,
  //   name: 'Bedre enn gjennomsnittet',
  //   description:
  //     'Gratulerer! Du bruker strøm på en smartere måte enn gjennomsnittet. Klarer du å bli enda smartere?'
  // },
  // {
  //   level: 2,
  //   name: 'Helt topp',
  //   description:
  //     'Du er en veldig bevisst og flink strømforbruker. Fortsett slik!'
  // }
];
